import type { rolesType } from "types/types";

export const SUPERUSER_ROLES = ["super_admin", "admin"];
export const GLOBAL_ROLES = [...SUPERUSER_ROLES, "rektor", "prorektor"];
export const RECTOR_ROLES = ["rektor", "prorektor"];
export const FACULTY_ROLES = ["faculty_admin", "dekan", "zam_dekan", "kafedra_mudiri"];
export const DIRECTION_ROLES = ["direction_admin"];
/** Every staff role that may open the analytics part of the web panel. */
export const ANALYTICS_ROLES = [
  ...GLOBAL_ROLES,
  ...FACULTY_ROLES,
  ...DIRECTION_ROLES,
  "teacher",
  "student",
];

export function normalizeRoleName(name: string | undefined | null): string {
  return (name ?? "").trim().toLowerCase().replace(/\s+/g, "_");
}

/** All normalized role names from the user (any order). */
export function getRoleNames(
  roles: rolesType[] | { name?: string }[] | undefined | null
): string[] {
  if (!roles?.length) return [];
  return roles.map((r) => normalizeRoleName(r.name as string));
}

/** True if the user has any of the given roles (case-insensitive). */
export function hasRole(
  roles: rolesType[] | { name?: string }[] | undefined | null,
  ...candidates: string[]
): boolean {
  const userRoles = getRoleNames(roles);
  const wanted = candidates.map((c) => normalizeRoleName(c));
  return userRoles.some((r) => wanted.includes(r));
}

type MeForRedirect = {
  roles?: { name?: string }[];
};

/** Landing page of the analytics section. */
export const ANALYTICS_HOME = "/analytics";

/** Post-login landing path: staff go to the new analytics section. */
export function getRedirectPathAfterLogin(me: MeForRedirect | undefined): string {
  const names = getRoleNames(me?.roles);

  // A user may combine a teacher role with an admin one: the analytics role wins.
  const staffRoles = [...GLOBAL_ROLES, ...FACULTY_ROLES, ...DIRECTION_ROLES];
  if (names.some((role) => staffRoles.includes(role))) {
    return ANALYTICS_HOME;
  }
  if (names.includes("teacher") || names.includes("student")) {
    return "/class-schedule";
  }
  return ANALYTICS_HOME;
}

/** 403 sahifasidan "Orqaga" — login bilan mos. */
export function getForbiddenRedirectPath(
  me: MeForRedirect | undefined
): string {
  if (!me?.roles?.length) {
    return "/login";
  }
  return getRedirectPathAfterLogin(me);
}
